import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'

export const List = styled.ul`
  display: flex;
  align-items: center;
  z-index: 1;
  &.atVideo {
    margin: 0 auto;
    gap: ${calculateResponsiveSize(40)};
  }
  &.atHeader {
    margin-left: ${calculateResponsiveSize(40)};
    gap: ${calculateResponsiveSize(29.5)};
  }
  .header-white &.atHeader {
    opacity: 0;
  }
  ${mediaMax('mobile')} {
    &.atHeader {
      margin: ${calculateMobileResponsiveSize(22)} auto 0;
      gap: ${calculateMobileResponsiveSize(22)};
      order: 1;
    }
    &.atVideo {
      margin: 0 auto;
      gap: 8.178117vw 10.178117vw;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`
export const Li = styled.li`
  display: flex;
  align-items: center;
  gap: ${calculateResponsiveSize(12)};
  position: relative;
  cursor: pointer;

  .onVideo & div {
    margin-left: ${calculateResponsiveSize(12)};
    margin-top: -${calculateResponsiveSize(3)};
  }
  .atHeader & {
    &:after {
      content: '';
      position: absolute;
      border: ${calculateResponsiveSize(4)} solid transparent;
      border-left: ${calculateResponsiveSize(8)} solid var(--blue);
      right: -${calculateResponsiveSize(4)};
      top: ${calculateResponsiveSize(3.5)};
    }
    &.active:after {
      top: ${calculateResponsiveSize(3)};
      right: -${calculateResponsiveSize(0)};
      border: ${calculateResponsiveSize(4)} solid transparent;
      border-top: ${calculateResponsiveSize(8)} solid var(--blue);
    }
    .header-white &,
    .header-black & {
      &:after {
        border-left: ${calculateResponsiveSize(8)} solid var(--light);
      }
      &.active:after {
        top: ${calculateResponsiveSize(3)};
        right: -${calculateResponsiveSize(0)};
        border: ${calculateResponsiveSize(4)} solid transparent;
        border-top: ${calculateResponsiveSize(8)} solid var(--light);
      }
    }
  }
  ${mediaMax('mobile')} {
    gap: ${calculateMobileResponsiveSize(12)};
    .onVideo & div {
      margin-left: ${calculateMobileResponsiveSize(12)};
      margin-top: -${calculateMobileResponsiveSize(3)};
    }
    .atHeader & {
      &:after {
        border: ${calculateMobileResponsiveSize(3)} solid transparent;
        border-left: ${calculateMobileResponsiveSize(6)} solid var(--blue);
        right: -${calculateMobileResponsiveSize(3)};
        top: ${calculateMobileResponsiveSize(3.5)};
      }
      &.active:after {
        top: ${calculateMobileResponsiveSize(4)};
        right: -${calculateMobileResponsiveSize(0)};
        border: ${calculateMobileResponsiveSize(3)} solid transparent;
        border-top: ${calculateMobileResponsiveSize(6)} solid var(--blue);
      }
      .header-white &,
      .header-black & {
        &:after {
          border-left: ${calculateMobileResponsiveSize(6)} solid var(--light);
        }
        &.active:after {
          top: ${calculateMobileResponsiveSize(4)};
          right: -${calculateMobileResponsiveSize(0)};
          border: ${calculateMobileResponsiveSize(3)} solid transparent;
          border-top: ${calculateMobileResponsiveSize(6)} solid var(--light);
        }
      }
    }
  }
`

export const Item = styled((props) => <Link {...props} />)`
  color: var(--blue);
  &:hover,
  &:active,
  &:visited {
    color: var(--blue);
    text-decoration: none;
  }
  display: flex;

  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  transition: 0.5s;
  text-transform: uppercase;

  .atVideo & {
    font-family: 'Basis Grotesque';
    font-size: ${calculateResponsiveSize(12)};
    font-weight: 700;
    line-height: ${calculateResponsiveSize(19.2)};
    letter-spacing: 0.1em;
    color: var(--light);
    &:hover,
    &:active,
    &:visited {
      color: var(--light);
      text-decoration: none;
    }
  }
  .atHeader & {
    padding-right: ${calculateResponsiveSize(14)};

    font-family: 'Basis Grotesque Pro';
    font-size: ${calculateResponsiveSize(10)};
    font-weight: 400;
    line-height: ${calculateResponsiveSize(16)};
    letter-spacing: ${calculateResponsiveSize(2)};
    .header-black & {
      color: var(--light);
    }
    .header-white & {
      color: var(--light);
    }
  }
  .atHeader .active & {
    font-weight: 700;
  }

  ${mediaMax('mobile')} {
    .atHeader & {
      padding-right: ${calculateMobileResponsiveSize(10)};
      font-size: ${calculateMobileResponsiveSize(10)};
      line-height: ${calculateMobileResponsiveSize(16)};
      letter-spacing: ${calculateMobileResponsiveSize(2)};
      white-space: nowrap;
    }
    .atVideo & {
      font-size: ${calculateMobileResponsiveSize(12)};
      line-height: ${calculateMobileResponsiveSize(19.2)};
    }
  }
`
export const MainLink = styled((props) => <Link {...props} />)`
  font-family: 'Canela';
  font-size: ${calculateResponsiveSize(18)};
  font-weight: 300;
  line-height: ${calculateResponsiveSize(28.8)};
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  padding-bottom: ${calculateResponsiveSize(5)};
  display: flex;
  flex-direction: column;
  height: ${calculateResponsiveSize(33)};
  margin-left: ${calculateResponsiveSize(90)};
  opacity: 1;
  & span {
    transform: translateY(0);
    transition: 0.5s;
  }
  &:hover {
    & span {
      transform: translateY(-${calculateResponsiveSize(28)});
    }
  }
  overflow: hidden;
  .header-black & {
    color: var(--light);
  }
  .header-white & {
    color: var(--light);
    opacity: 0;
  }
  ${mediaMax('mobile')} {
    margin-left: ${calculateMobileResponsiveSize(60)};
    font-size: ${calculateMobileResponsiveSize(18)};
    line-height: ${calculateMobileResponsiveSize(28.8)};
    flex: 0 0 auto;
    padding-top: ${calculateMobileResponsiveSize(1)};
    height: ${calculateMobileResponsiveSize(33)};
  }
`
